import { render } from "./Stack.vue?vue&type=template&id=45a7a3b9&scoped=true"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"

import "./Stack.vue?vue&type=style&index=0&id=45a7a3b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a7a3b9"]])

export default __exports__